module.exports = __webpack_public_path__ + "img/btn1.fc51d42d.png";